var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c("div", { staticClass: "col-xs-12" }, [
      _c("div", { staticClass: "form-field select2" }, [
        _c(
          "div",
          { staticClass: "select2-field" },
          [
            _c("v-select", {
              attrs: {
                placeholder: "Realice una consulta...",
                id: "geocerca",
                label: "nombre",
                options: _vm.clientesExistentes
              },
              on: { search: _vm.onSearchClientes, input: _vm.inputCliente },
              model: {
                value: _vm.selectedCliente,
                callback: function($$v) {
                  _vm.selectedCliente = $$v
                },
                expression: "selectedCliente"
              }
            }),
            _vm._v(" "),
            _c("label", { attrs: { for: "geocerca" } }, [_vm._v("Cliente")])
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "col-xs-12" }, [
      _c(
        "div",
        {
          staticClass: "table-responsive",
          staticStyle: { "max-height": "300px" }
        },
        [
          _c("table", [
            _vm._m(0),
            _vm._v(" "),
            _c(
              "tbody",
              [
                _vm._l(_vm.clientes, function(cliente, index) {
                  return _c("tr", { key: cliente.id }, [
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(cliente.nombre) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(cliente.direccion) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(cliente.latitud) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(cliente.longitud) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                cliente.latitud != "" &&
                                cliente.longitud != "" &&
                                cliente.latitud != null &&
                                cliente.longitud != null,
                              expression:
                                "cliente.latitud != '' && cliente.longitud != '' && cliente.latitud != null && cliente.longitud != null"
                            }
                          ],
                          staticClass: "btn-primary btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.ver(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-eye" })]
                      ),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn-danger btn--text",
                          attrs: { type: "button" },
                          on: {
                            click: function($event) {
                              return _vm.eliminar(index)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fa fa-times" })]
                      )
                    ])
                  ])
                }),
                _vm._v(" "),
                _c(
                  "tr",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.clientes.length === 0,
                        expression: "clientes.length === 0"
                      }
                    ]
                  },
                  [_vm._m(1)]
                )
              ],
              2
            )
          ])
        ]
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Cliente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Dirección")]),
        _vm._v(" "),
        _c("th", [_vm._v("Latitud")]),
        _vm._v(" "),
        _c("th", [_vm._v("Longitud")]),
        _vm._v(" "),
        _c("td")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "5" } }, [
      _c("strong", [_vm._v("No se ha agregado clientes")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-f8f7de0c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f8f7de0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/ClientesRuta.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-f8f7de0c","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/logistica/rutas/ClientesRuta.vue
// module chunks = 0